module.exports = __webpack_public_path__ + "static/media/Illustration_FlyerGuidelines_Fancy.bce1eebe.svg";